export default "__VITE_ASSET__BdwmC8w7__"